import { render } from "./AutenticacaoSIOP.vue?vue&type=template&id=668e2d5b&scoped=true"
import script from "./AutenticacaoSIOP.vue?vue&type=script&lang=js"
export * from "./AutenticacaoSIOP.vue?vue&type=script&lang=js"

import "@siop/standard-libui/dist/css/bootstrap-4/siop.css?vue&type=style&index=0&id=668e2d5b&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-668e2d5b"]])

export default __exports__